import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { QRData } from '../components/self-scanning-instructions/self-scanning-instructions.component';

const BASE_URL = environment.base_url_second;
  
export interface CreateQRRequest {
    QRData: QRData;
    createdAt: number;
}

export interface CreateQRResponse {
    message: string;
}

@Injectable({
    providedIn: 'root'
})
export class QRService {

    constructor(private http: HttpClient) {}

    getQRbyCode(code: string): any {
        const url = `${BASE_URL}/qr/${code}`;

        return this.http.get(url)
    }

    createQR(QRData: QRData) {
        const url = `${BASE_URL}/qr`;
        const payload: CreateQRRequest = {
            QRData,
            createdAt: Date.now()
        } 
        return this.http.post<CreateQRResponse>(url, payload);
    }
}
